import React, { useState } from "react";
import classes from "./style.module.css";
import EitaIcon from "../../../assets/images/icons/EitaIcon.svg";
import { FaSquarePhoneFlip } from "react-icons/fa6";
import PhoenesDialog from "./PhoenesDialog";

const socialMediaIcons = [
  {
    name: "تماس با روابط‌عمومی",
    icon: <FaSquarePhoneFlip size={21} color="var(--secondary500)" />,
    link: "",
  },
  {
    name: "پشتیبان امور فرهنگی",
    img: EitaIcon,
    link: "https://eitaa.com/msc_cul_admin",
  },
  {
    name: "کانال امور فرهنگی",
    img: EitaIcon,
    link: "https://eitaa.com/msc_cul",
  },
  {
    name: "کانال جفت پوچ",
    img: EitaIcon,
    link: "https://eitaa.com/msc_joftpuch",
  },
  // {
  //   name: "پشتیبان جفت پوچ",
  //   img: EitaIcon,
  //   link: "https://eitaa.com/Admin_joftpuch",
  // },
  // {
  //   name: "پشتیبان فنی",
  //   icon: EitaIcon,
  //   link: "https://eitaa.com/msc_tech",
  // },
];

const SocialSec = () => {
  const [showModal, setShowModal] = useState(false);
  function handleClick(link) {
    if (link) {
      window.open(link, "_blank");
    } else {
      setShowModal(true);
    }
  }

  let socialMediaSec = socialMediaIcons.map((media, index) => {
    return (
      <div
        className="col-3 text-center mt-4"
        key={index}
        onClick={() => handleClick(media.link)}
      >
        {media.icon ? (
          media.icon
        ) : (
          <img src={media.img} alt="social-media-icon" />
        )}

        <p className={classes.socialMediaName}>{media.name}</p>
      </div>
    );
  });
  return (
    <>
      <div className={classes.socialSecContainer}>
        <div className={classes.socialSecTitle}>
          <span>شبکه های اجتماعی</span>
        </div>
        <div className="row m-0 p-0 justify-content-center">
          {socialMediaSec}
        </div>
      </div>
      <PhoenesDialog show={showModal} handleClose={() => setShowModal(false)} />
    </>
  );
};

export default SocialSec;
